module.exports = __webpack_public_path__ + "static/media/Ahmedabad.a827ee8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/Ahmedabad.jpg
// module id = 996
// module chunks = 0